import * as moment from 'moment'
export class UrlVariable {

  //API LOCAL

  // TEST 

  // public static readonly URL_KPI = 'http://localhost:3100';
  public static readonly URL_KPI = 'https://kpi.api.ttithutech.com';

  public static readonly URL_LOGIN = 'https://api.lamgigio.net/core-phan-quyen/api-authentication';
  public static readonly URL_FILES = 'https://newsapi.lamgigio.net/files';
  public static readonly URL_API_CAU_HINH_CHUNG = 'https://api.lamgigio.net/cauhinhchung';

  // public static readonly URL_LOGIN = 'http://api.hutech.edu.vn';
  // public static readonly URL = 'http://api.hutech.edu.vn';

  //API BETA RELEASE TEST
  // public static readonly URL_LOGIN = 'http://apibeta.hutech.edu.vn';
  // public static readonly URL = 'http://apibeta.hutech.edu.vn';

  public static readonly URL_INSERT_EMAIL = 'https://api.lamgigio.net/email';
  // public static readonly URL_LOG = 'http://test6.hutech.edu.vn';
  public static readonly URL_LOG = 'http://log.hutech.edu.vn';

  /**
   * domain để setup kcfinder
   */
  public static readonly DOMAIN = `https://erp1.hutech.edu.vn`;
}

export class Version {
  public static readonly APP_ID = "MOBILE_HUTECH";
  public static readonly VERSION = "VERSION";
  public static readonly VERSION_ID = "0.0.2";
}

export class MenuAuthen {
  public static readonly quan_ly = 456;
  public static readonly sinh_vien = 457;
  /** quyền tải file in kế hoạch; -1 = không giới hạn (directive myauthen bỏ qua) */
  public static readonly WEB_NQLD_QUYEN_MACTION_KPI_IN = -1;

  /*
    Group KPI - menu left (directive myauthen)
    Quy ước: -1 = không giới hạn quyền. Thay -1 bằng id menu thật từ hệ thống phân quyền khi đã cấu hình.
  */
  public static readonly WEB_KPI_QUYEN_MLEFT = -1;                        // web: menu left - KPI (group Kế hoạch năm)
  public static readonly WEB_KPI_QUYEN_MLEFT_LAP_KE_HOACH = -1;           // web: menu left - KPI - Lập kế hoạch (/admin/kpi/nam-nay-tab)
  public static readonly WEB_KPI_QUYEN_MLEFT_DUYET_KE_HOACH = -1;         // web: menu left - KPI - Duyệt kế hoạch (/admin/kpi/don-vi)
  public static readonly WEB_KPI_QUYEN_MLEFT_THONG_KE = -1;               // web: menu left - KPI - Thống kê (/admin/kpi/thong-ke)
  public static readonly WEB_KPI_QUYEN_MLEFT_CAI_DAT = -1;                // web: menu left - KPI - Cài đặt (group)
  public static readonly WEB_KPI_QUYEN_MLEFT_CAI_DAT_MAU_KPI = -1;        // web: menu left - KPI - Cài đặt - Mẫu KPI (/admin/kpi/cai-dat/kpi)
  public static readonly WEB_KPI_QUYEN_MLEFT_CAI_DAT_NGUOI_DUNG = -1;     // web: menu left - KPI - Cài đặt - Người dùng (/admin/kpi/cai-dat/user-tag/list)
}





export class ErrorVariable {
  public static readonly CONNECTION_REFUED = 1321;
}

export class ResponseStatusCode {
  public static readonly CONNECTION_REFUED = 0;
}

export class StateVariable {
  public static readonly EDIT = 1;
  public static readonly CREATE = 2;
}
export class CkEditorConfig {
  public static readonly CKEDITOR_CONFIG = {
    uiColor: '#F0F3F4',
    height: '400',
    toolbar: [
      { name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates', 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo', 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt', 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat', 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language', 'Link', 'Unlink', 'Anchor', 'Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe', 'Styles', 'Format', 'Font', 'FontSize', 'TextColor', 'BGColor', 'Maximize', 'ShowBlocks', 'About'] }
    ],
    resize_enabled: true,
    filebrowserBrowseUrl: 'http://admin.fhouse.vn/test/ckfinder.html',
    filebrowserUploadUrl: `http://admin.fhouse.vn/test/core/connector/php/connector.php?command=QuickUpload&type=Files`

  };
  public static readonly CKEDITOR_CONFIG_KPI = {
    uiColor: '#F0F3F4',
    height: '200',
    toolbarGroups: [
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'clipboard', groups: ['undo', 'clipboard'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
      { name: 'forms', groups: ['forms'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'align', 'bidi', 'paragraph'] },
      { name: 'links', groups: ['links'] },
      // { name: 'insert', groups: ['insert'] },
      // { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },
      { name: 'tools', groups: ['tools'] },
      { name: 'others', groups: ['others'] },
      { name: 'about', groups: ['about'] }
    ],
    resize_enabled: true,
    filebrowserBrowseUrl: `${UrlVariable.DOMAIN}/plugin/browse.php`,
    filebrowserUploadUrl: `${UrlVariable.DOMAIN}/plugin/upload.php`,
    filebrowserImageBrowseUrl: `${UrlVariable.DOMAIN}/plugin/browse.php?type=images`,
    filebrowserImageUploadUrl: `${UrlVariable.DOMAIN}/plugin/upload.php?type=images`,
    removeButtons: 'Save,NewPage,Preview,Print,Templates,Paste,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Superscript,Subscript,Strike,CopyFormatting,Indent,Outdent,CreateDiv,Anchor,Language,BidiRtl,BidiLtr,Flash,HorizontalRule,Smiley,PageBreak,Iframe,Styles,Font,FontSize,BGColor,TextColor,Maximize,ShowBlocks,About,SpecialChar,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock',
    // extraPlugins: "embed",
    extraAllowedContent: "iframe[*];video[*];source[*];",
    allowedContent: true,
    // embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}'
  }
}


/**
 * Thời gian hết hạn của Cookie
 */
export class CookieConfig {
  /**Thời gian chết của cookie */
  public static readonly EXPIRES = 7;
  /**Tên Object lưu dưới cookie Authen */
  public static readonly AUTHEN_COOKIE = 'Auth-menu';
  public static readonly IMAGE_COOKIE = 'Image-menu';
  public static readonly NVID_COOKIE = 'Nvid-menu';
  public static readonly NAME_COOKIE = 'name-menu';
}

/**
 * @author Bình
 * một mảng đối tượng gồm id và ten của trạng thái xử lý
 */
export let TrangThaiXuLySuCo = [
  { id: 1, text: 'Đợi xử lý' },
  { id: 2, text: 'Đang xử lý' },
  { id: 0, text: 'Xong' },
]

export class ImageVariables {
  // public static readonly IMAGE_DOMAIN = 'http://localhost:3100';

  // test
  public static readonly IMAGE_DOMAIN = 'http://newsapi.lamgigio.net/files';

  // release
  // public static readonly IMAGE_DOMAIN = 'http://api.xemgigio.net/adminnews';

  public static readonly SLIDE_SHOW_RESOLUTION_WIDTH = 1024;
  public static readonly SLIDE_SHOW_RESOLUTION_HEIGHT = 768;
}
/**
 * Xử lý dropdown list
 */
export class CurrentStatus {
  public static readonly CURRENT_STATUS_MAP = [
    { id: -1000, value: "error", text: "KHÔNG CÓ GIÁ TRỊ", icon: "fa fa-exclamation-circle fg-crimson" },
    { id: 1, value: "active", text: "Hoạt động", icon: "fa fa-check fg-lightGreen" },
    { id: 0, value: "deactive", text: "Không hoạt động", icon: "fa fa-times fg-crimson" },
    { id: -1, value: "lock", text: "Khóa", icon: "fa fa-lock fg-orange" },
    { id: 2, value: "spending", text: "Đang xử lí", icon: "fa fa-spinner fg-brown" },
  ];

  public static readonly FIND = (value) => {
    return CurrentStatus.CURRENT_STATUS_MAP.find(e => e.value == value) || CurrentStatus.CURRENT_STATUS_MAP[0]
  }

  public static readonly PICK = (values: any[]) => {
    return CurrentStatus.CURRENT_STATUS_MAP.filter(e => values.indexOf(e.value) !== -1)
  }

  public static readonly GETALL = () => {
    return CurrentStatus.CURRENT_STATUS_MAP
  }
}
export class Tinh_Trang {
  public static readonly BAN_NHAP = 0;
  public static readonly DANG_XU_LY = 1;
  public static readonly HOAN_TAT = 2;
  public static readonly TINH_TRANG_LIST = [
    { id: 0, value: 0, text: "Bản nháp" },
    { id: 1, value: 1, text: "Đang xử lý" },
    { id: 2, value: 2, text: "Hoàn tất" }
  ]

  public static readonly TINH_TRANG_MAP = [
    { id: -1000, value: "error", text: "", class: "fa fa-exclamation-circle fg-crimson", note: 'Không xác định' },
    { id: 0, value: 0, text: "Bản nháp", class: "label label-default txt-color-white text-center" },
    { id: 1, value: 1, text: "Đang xử lí", class: "label label-warning  txt-color-white text-center" },
    { id: 2, value: 2, text: "Hoàn tất", class: "label label-success txt-color-white text-center" },
  ];
  public static readonly FIND = (value) => {
    return Tinh_Trang.TINH_TRANG_MAP.find(e => e.value == value) || Tinh_Trang.TINH_TRANG_MAP[0]
  }

  public static readonly PICK = (values: any[]) => {
    return Tinh_Trang.TINH_TRANG_MAP.filter(e => values.indexOf(e.value) !== -1)
  }

  public static readonly GETALL = () => {
    return Tinh_Trang.TINH_TRANG_MAP
  }
}
export class Paging {
  public static readonly PAGING = [
    { value: 10, text: '10 dòng' },
    { value: 20, text: '20 dòng' },
    { value: 50, text: '50 dòng' },
    { value: 100, text: '100 dòng' },
    { value: 200, text: '200 dòng' }
  ];
}
export class DateLocaleVariable {
  public static readonly VIETNAM_LOCALESTRING = 'vi-VN';
  // https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript
}


/**
* Xử lý thời gian
*/
export class DateTimePicker {
  public static readonly DATESQLFORMAT = "YYYY-MM-DD HH:mm";
  public static readonly TIMEVIEWFORMAT = "HH:mm";
  public static readonly TIMEFORMAT = "YYYY/MM/DD HH:mm";
  public static readonly DATEFORMAT = "YYYY/MM/DD";
  public static readonly DATEVIEWFORMAT = "DD/MM/YYYY";
  public static readonly DATEPICKEROPTIONS = {
    todayBtnTxt: 'Hôm nay',
    dateFormat: 'dd/mm/yyyy',
    placeholder: "dd/mm/yyyy",
    editableDateField: false,
    openSelectorOnInputClick: true
  };

  public static readonly DATEFORMAT_I18N = {
    date: {
      "en": "DD/MM/YYYY",
      "vi": "DD/MM/YYYY",
      "ru": "MM/DD/YYYY",
      "jp": "YYYY年MM月DD日"
    },
    full: {
      "en": "DD/MM/YYYY HH:mm:ss",
      "vi": "DD/MM/YYYY HH:mm:ss",
      "ru": "MM/DD/YYYY HH:mm:ss",
      "jp": "YYYY年MM月DD日 HH:mm:ss"
    }
  };
  public static readonly DATEPICKEROPTIONS_I18N = {
    vi: {
      todayBtnTxt: 'Hôm nay',
      dateFormat: 'dd/mm/yyyy',
      placeholder: "dd/mm/yyyy",
      editableDateField: false,
      openSelectorOnInputClick: true
    },
    en: {
      todayBtnTxt: 'Today',
      dateFormat: 'dd/mm/yyyy',
      placeholder: "dd/mm/yyyy",
      editableDateField: false,
      openSelectorOnInputClick: true

    }
  };

  // this.placeholder = dateFormat["date"][this.lang].toLowerCase()
  public static readonly SETNOW = (form, property) => {
    let date = new Date();
    let value = {};
    value[property] = {
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      },
      jsdate: date
    }
    form.patchValue(value);
  };

  public static readonly SETDATE = (form, property, dateValue) => {
    if (!dateValue) {
      return;
    }
    let date = moment(dateValue, 'DD-MM-YYYY HH:mm:ss')
    let value = {};
    value[property] = {
      date: {
        year: date.get('year'),
        month: date.get('month') + 1,
        day: date.get('date')
      },
      jsdate: date
    }
    form.patchValue(value);
  };

  public static readonly CLEARDATE = (form) => {
    form.patchValue({ myDate: null });
  };
}

export class NotificationVariable {
  // Số lượng dữ liệu để được coi là dữ liệu lớn 
  public static readonly LARGE_DATA = 5000;
  public static readonly NOTIFICATIONS_CATEGORIES_ID = 22;
  public static readonly THONGBAO_CATEGORIES_ID = 23;
  // public static readonly THONGBAO_PAGE_ID = 23;
  // Mã lỗi khi token ảo
  public static readonly TOKEN_ERROR = "NotRegistered";
  // Mã lỗi khi sai sender_id
  public static readonly SENDER_ID_ERROR = "MismatchSenderId";
}
export class DanhMucVariable {
  public static readonly DANHMUC_CATEGORIES_ID = 17;
  public static readonly DANHMUC_LANDINGPAGE_FORMDK = 18;
}
export class Loai_Cham_Cong {
  public static readonly RA = 'RA';
  public static readonly VAO = 'VAO';
}
// export class LoaiGioLamId {
//   public static readonly NGHI = 3;
//   public static readonly CONG_TAC_HOC_TAP = 4;
// }
// export class LOAI_PHIEU {
//   public static readonly ID_PHIEU_NGHI = 3;
//   public static readonly ID_PHIEU_CONG_TAC_HOC_TAP = 4;
//   public static readonly LOAI_PHIEU_LIST = [
//     { id: LOAI_PHIEU.ID_PHIEU_NGHI, value: 3, text: "Phiếu nghỉ phép" },
//     { id: LOAI_PHIEU.ID_PHIEU_CONG_TAC_HOC_TAP, value: 4, text: "Phiếu công tác - học tập" }
//   ]
//   public static readonly FIND = (value) => {
//     return LOAI_PHIEU.LOAI_PHIEU_LIST.find(e => e.value == value) || LOAI_PHIEU.LOAI_PHIEU_LIST[0]
//   }
// }


// WEBPACK FOOTER //
// ./src/app/util/variable.ts